import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/requisitions')({
  component: RequisitionsPage,
});

function RequisitionsPage() {
  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-3xl font-bold mb-6">Requisitions</h1>
      <p className="text-muted-foreground">
        Manage and view job requisitions. This page is under development.
      </p>
    </div>
  );
}
